module.exports = __webpack_public_path__ + "images/application/templates/blank@2x-70a1303a.png";